import React, { useState, useEffect, useRef, useMemo } from "react";
import { useParams, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import "../PlatinumProgram/index.scss";
import ChatContainer from "../Chat/ChatContainer";
import Support from "./Support";
import { Button, IconButton } from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";
import CloseIcon from "@mui/icons-material/Close";
import EditNoteIcon from "@mui/icons-material/EditNote";
import PreviousVideos from "../BasicsTraining/PreviousVideos";
import { defaultVideoState } from "../../helpers/defaultVideoState";
import LivestreamPage from "../common/LivestreamPage";
import AuthorAvatar from "../../assets/images/brian-profile.jpg";
import FaqBubble from "../../assets/images/faq-bubble.png";
import NotificationBell from "../../assets/images/notification-bell.png";
import NotificationBellLight from "../../assets/images/alert-icon-light.png";
import FaqBubbleLight from "../../assets/images/faq-icon-light.png";
import Rules from "../../assets/images/rules.png";
import RulesLight from "../../assets/images/notes-icon-light.png";
import { useAuth } from "../../contexts/Auth";
import { OpenChannel, SendBirdProvider } from "sendbird-uikit";
import "sendbird-uikit/dist/index.css";
import TradeMessage from "../Chat/TradeMessage";
import { tradeMessagesLoad } from "../../appRedux/ducks/tradeChat";
import { updateTradeStatusLoad } from "../../appRedux/ducks/updateTradeStatus";
import { BRIAN_USER_ID } from "../../helpers/userRoles";

const DayTradeWithBrian = ({
  themeMode,
  tradeMessagesSocket,
  tradeMessages,
  getTradeMessages,
  updateTradeStatus,
}) => {
  const [currentNav, setCurrentNav] = useState("real-time-trading-alerts");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const hardHistory = useHistory();
  const { tab } = useParams();
  const [videoTab, setVideoTab] = useState("1");
  const [currentVideo, setCurrentVideo] = useState(defaultVideoState);
  const { authUser, userData } = useAuth();

  const appId = process.env.REACT_APP_SENDBIRD_APP_ID;
  const tradeChannelUrl = process.env.REACT_APP_SENDBIRD_TRADE_CHANNEL_URL;

  const nickName = useMemo(() => {
    return userData ? userData?.display_name || "" : "";
  }, [JSON.stringify(userData)]);

  const [stringSet] = useState({
    PLACE_HOLDER__NO_CHANNEL: "",
  });

  const openChannelProps = useMemo(() => {
    const isCommonUser = authUser !== BRIAN_USER_ID;
    const props = {
      ...(isCommonUser && { renderMessageInput: () => <></> }),
    };
    return props;
  }, [authUser]);

  const isAnalyst = useMemo(() => {
    return authUser === BRIAN_USER_ID;
  }, [authUser]);

  useEffect(() => {
    getTradeMessages();
  }, []);
  const selectNavigation = (nav) => {
    if (nav === "support") {
      hardHistory.push(`/live-chat/support`);
    } else {
      hardHistory.push(`/live-chat/${nav}`);
    }
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  const doNavigation = (tab) => {
    setCurrentNav(tab);
  };

  useEffect(() => {
    doNavigation(tab);
  }, [tab]);

  const Modal = ({ isOpen, onClose, children }) => {
    const modalRef = useRef(); // Ref for the modal content

    useEffect(() => {
      const handleOutsideClick = (event) => {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
          onClose(); // Close the modal if the click is outside
        }
      };

      const handleEscapePress = (event) => {
        if (event.key === "Escape") {
          onClose(); // Close the modal if Escape key is pressed
        }
      };

      if (isOpen) {
        document.addEventListener("mousedown", handleOutsideClick);
        document.addEventListener("keydown", handleEscapePress);
      }

      return () => {
        // Cleanup the event listeners when the component unmounts or modal is closed
        document.removeEventListener("mousedown", handleOutsideClick);
        document.removeEventListener("keydown", handleEscapePress);
      };
    }, [isOpen, onClose]); // Dependencies array ensures effect runs only if `isOpen` or `onClose` changes

    if (!isOpen) return null;

    return (
      <div className="modal-overlay">
        <div className="modal-content" ref={modalRef}>
          <IconButton onClick={onClose} className="close-button close-modal">
            <CloseIcon />
          </IconButton>
          {children}
        </div>
      </div>
    );
  };

  return (
    <div>
      <div className="live-chat-page-navigator">
        <div className="live-chat-page-nav-items">
          <div
            className={`live-chat-page-navItem ${currentNav === "real-time-trading-alerts" ? "active" : ""}`}
            onClick={() => selectNavigation("real-time-trading-alerts")}
          >
            Real-time Trading Alerts
          </div>
          <div
            className={`live-chat-page-navItem ${currentNav === "livestream" ? "active" : ""}`}
            onClick={() => selectNavigation("livestream")}
          >
            Livestream
          </div>
          <div
            className={`live-chat-page-navItem ${currentNav === "support" ? "active" : ""}`}
            onClick={() => selectNavigation("support")}
          >
            Support
          </div>
        </div>
        <Button
          className="rules-button"
          onClick={() => setIsModalOpen(true)}
          startIcon={<ErrorIcon sx={{ color: "white !important" }} />}
          fullWidth
        >
          CLICK HERE FOR THE GUIDELINES OF THIS ROOM TO TRADE SUCCESSFULLY
        </Button>
      </div>
      <div className="platinum-program-page-main-view">
        {currentNav === "real-time-trading-alerts" && (
          <ChatContainer setTab={selectNavigation} tab={currentNav} />
        )}
        {currentNav === "livestream" && (
          <>
            <div className="top-block-wrapper">
              <div
                className={`sendbird-theme--${themeMode} sendbird-openchannel-app first-chat-wrapper`}
              >
                <LivestreamPage
                  eventID="3395808"
                  videoKey="brian"
                  customBodyComponent={
                    <div style={{ paddingTop: "9px" }}>
                      <div className="openchannel-description">
                        <div className="platinum-program-page-live-streams-info-header pl-15">
                          <img
                            src={AuthorAvatar}
                            alt="Brian"
                            className="live-streams-author"
                          />
                          <div className="platinum-program-page-live-streams-author-info">
                            <div className="platinum-program-page-live-streams-author-name">
                              Brian Mitchell
                            </div>
                            <div className="platinum-program-page-live-streams-author-job">
                              TradeAlgo Professional Analyst
                            </div>
                          </div>
                        </div>
                        <div className="platinum-program-page-live-streams-info-content">
                          <div className="platinum-program-page-live-streams-title pl-15">
                            Day Trading With Brian
                          </div>
                          <div className="platinum-program-page-live-streams-description pl-15">
                            Join Brian in his Day Trading Sessions as he shares
                            his expertise and insights into the world of
                            trading. You&apos;ll receive trading alerts from
                            Brian himself live and learn the reasoning behind
                            each trade he makes. Join the community as well to
                            interact with other like minded traders and Brian
                            himself. Whether you&apos;re a new trader just
                            starting out or an experienced one looking to secure
                            profitable gains, with Brian&apos;s guidance,
                            you&apos;ll be able to use this method to make
                            informed decisions and achieve your trading goals.
                          </div>
                        </div>
                      </div>
                      <div className="mt-15 openchannel-description">
                        <div className="basics-training-event-schedule-status">
                          LIVE Schedule
                        </div>
                        <div className="basics-training-event-schedule-day">
                          Monday - Friday
                        </div>
                        <div className="basics-training-event-schedule-time">
                          Time: 10:30am EST - 11:30am EST
                        </div>
                      </div>
                      <div className="description-block-wrapper">
                        <div className="description-blocks">
                          <span className="title">Real-Time Alerts</span>
                          <div className="image-title-description">
                            <img
                              src={
                                themeMode === "light"
                                  ? NotificationBell
                                  : NotificationBellLight
                              }
                              className="bell"
                            />
                            <div className="title-description">
                              <span className="inner-title">
                                Real-Time Alerts & Support
                              </span>
                              <span className="inner-description">
                                Brian Mitchell provide profitable Trade Alerts
                                and answers question in the live Trade Board and
                                Chat
                              </span>
                            </div>
                          </div>
                          <Button
                            onClick={() =>
                              selectNavigation("real-time-trading-alerts")
                            }
                            className="supports-widget-item-button"
                          >
                            Real-Time Alerts
                          </Button>
                        </div>
                        <div className="description-blocks">
                          <span className="title">Support</span>
                          <div className="image-title-description">
                            <img
                              src={
                                themeMode === "light"
                                  ? FaqBubble
                                  : FaqBubbleLight
                              }
                              className="bell"
                            />
                            <div className="title-description">
                              <span className="inner-title">
                                Freqently Asked Questions
                              </span>
                              <span className="inner-description">
                                Get answers to your commonly asked questions
                              </span>
                            </div>
                          </div>
                          <Button
                            onClick={() => selectNavigation("support")}
                            className="supports-widget-item-button"
                          >
                            FAQs
                          </Button>
                        </div>
                      </div>
                    </div>
                  }
                  showPreviousVideos={false}
                  customPageSize={19}
                  className="daytrade-brian-page"
                  currentVideo={currentVideo}
                  setCurrentVideo={setCurrentVideo}
                />
              </div>
              {/* Board Guide - Right Side */}
              <div className="second-chat-wrapper">
                <div className="openchannel-app-trades-guide">
                  <div className="guide-title">Board Guide</div>
                  <div className="trade-colors">
                    <div className="color-wrapper">
                      <div className="green-bar"></div>
                      <div className="green-trade">Open Trade</div>
                    </div>
                    <div className="color-wrapper">
                      <div className="yellow-bar"></div>
                      <div className="yellow-trade">Running Trade</div>
                    </div>
                    <div className="color-wrapper">
                      <div className="red-bar"></div>
                      <div className="red-trade">Closed Trade</div>
                    </div>
                  </div>
                </div>
                {/* OPEN TRADES CHAT */}
                <div
                  className={`sendbird-theme--${themeMode} sendbird-openchannel-app-trades`}
                >
                  <SendBirdProvider
                    appId={appId}
                    userId={authUser}
                    nickname={nickName}
                    stringSet={stringSet}
                  >
                    <div
                      className="sendbird-openchannel-app__channel"
                      style={{ overflow: "hidden" }}
                    >
                      <OpenChannel
                        channelUrl={tradeChannelUrl}
                        disableUserProfile
                        {...openChannelProps}
                        renderCustomMessage={(message) => {
                          const renderTradeMessage = () => (
                            <TradeMessage
                              themeMode={themeMode}
                              isAnalyst={isAnalyst}
                              updateStatus={updateTradeStatus}
                              dbMessages={tradeMessages}
                              wsMessages={tradeMessagesSocket}
                              message={message}
                            />
                          );
                          return renderTradeMessage;
                        }}
                      ></OpenChannel>
                    </div>
                  </SendBirdProvider>
                </div>
                <div className="rules-section visually-hidden display-none">
                  <div className="top-notes">
                    <img
                      src={themeMode === "light" ? Rules : RulesLight}
                      className="wh-27"
                    />
                    <div className="analyst-rules">Rules From Analyst</div>
                  </div>
                  <span className="desc-style">
                    <li className="bullets-rule">
                      Please have a set position size for trades explicitly
                      mentioned: Superlotto, lotto, and small sized
                    </li>
                    <li className="bullets-rule">
                      No complaining/negativity- 2 strikes and you will be
                      kicked from chat
                    </li>
                    <li className="bullets-rule">
                      When trades reach 20% profit, stop is set to break even
                      unless they are superlotto positions (no stoploss)
                    </li>
                    <li className="bullets-rule">
                      Brian&apos;s stop is automatically 30% from entry for all
                      trades (except for superlottos)
                    </li>
                    <li className="bullets-rule">
                      After a trade is 10% or more from Brian&apos;s entry,{" "}
                      <b>NOT</b> recommended to chase position
                    </li>
                    <li className="bullets-rule">
                      Brian will alert when there is a good risk to reward,{" "}
                      <b>PLEASE DONT ASK FOR TRADES</b>
                    </li>
                    <li className="bullets-rule">
                      If you ask to look at a stock, Brian will only do so with
                      a premise/reason from a technical analysis standpoint +
                      time frame
                    </li>
                    <li className="bullets-rule">
                      Superlottos are <b>RISKY</b> by nature. They have no
                      stoploss and a majority of our trades lately
                    </li>
                  </span>
                  <a
                    href="https://docs.google.com/document/d/1NLoLcZm6YorkdCU60N6SEff0PjDSyJXQ_XKIazSEWUw/edit?pli=1"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="full-notes"
                  >
                    Click to view all rules
                  </a>
                </div>
              </div>
            </div>
            <PreviousVideos
              tab={videoTab}
              setTab={setVideoTab}
              basics={false}
              currentVideo={currentVideo}
              setCurrentVideo={setCurrentVideo}
              videoKey={"brian"}
            />
          </>
        )}
        {currentNav === "support" && (
          <Support tab={currentNav} setTab={selectNavigation} />
        )}
      </div>
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <div className="rules-list">
          <div className="modal-header brian-modal">
            <EditNoteIcon className="edit-note-icon" />
            <div className="analyst-rules">Rules From Analyst</div>
          </div>
          <span className="desc-style">
            <li className="bullets-rule">
              Please have a set position size for trades explicitly mentioned:
              Superlotto, lotto, and small sized
            </li>
            <li className="bullets-rule">
              No complaining/negativity- 2 strikes and you will be kicked from
              chat
            </li>
            <li className="bullets-rule">
              When trades reach 20% profit, stop is set to break even unless
              they are superlotto positions (no stoploss)
            </li>
            <li className="bullets-rule">
              Brian&apos;s stop is automatically 30% from entry for all trades
              (except for superlottos)
            </li>
            <li className="bullets-rule">
              After a trade is 10% or more from Brian&apos;s entry, NOT
              recommended to chase position
            </li>
            <li className="bullets-rule">
              Brian will alert when there is a good risk to reward,{" "}
              <b>PLEASE DONT ASK FOR TRADES</b>
            </li>
            <li className="bullets-rule">
              If you ask to look at a stock, Brian will only do so with a
              premise/reason from a technical analysis standpoint + time frame
            </li>
            <li className="bullets-rule">
              Superlottos are <b>RISKY</b> by nature. They have no stoploss and
              a majority of our trades lately
            </li>
          </span>
          <a
            href="https://docs.google.com/document/d/1NLoLcZm6YorkdCU60N6SEff0PjDSyJXQ_XKIazSEWUw/edit?pli=1"
            target="_blank"
            rel="noopener noreferrer"
            className="full-notes"
          >
            Click to view all rules
          </a>
        </div>
      </Modal>
    </div>
  );
};

const stateToProps = (state) => ({
  themeMode: state.themeMode.themeMode,
  tradeMessagesSocket: state.Socket.tradeMessages,
  tradeMessages: state.tradeChat.tradeMessages,
});

const dispatchToProps = (dispatch) => ({
  getTradeMessages: () => dispatch(tradeMessagesLoad()),
  updateTradeStatus: (trade_status, message_id) =>
    dispatch(updateTradeStatusLoad(trade_status, message_id)),
});

export default connect(stateToProps, dispatchToProps)(DayTradeWithBrian);
